export const sortableSearchResultListColumns = {
  AUTH_REF_TYPE: 'authRefType',
  HEADING_REF: 'headingRef',
  HEADING_TYPE: 'headingType',
};
